import { useNavigate } from 'react-router-dom';
import { ymGoal } from '@/lib/analytics';
import { QUESTION_BUTTONS, horarUrlFor } from '@/lib/questionEntry';

/**
 * «Вход через вопрос» — первый экран главной.
 *
 * Нажатие кнопки = вопрос задан в этот момент: переход в хорар, который сам
 * строит карту вопроса без ввода (/horar?ask=…, см. HoraryPage). Какая
 * кнопка какой вопрос хорара задаёт — таблица в lib/questionEntry.js.
 *
 * Заголовок — h2, а не h1: h1 страницы остаётся «натальная карта», по нему
 * главная ранжируется.
 */
export default function QuestionHero({ className = '' }) {
  const navigate = useNavigate();

  const ask = (button) => {
    ymGoal('question_click', { button: button.label });
    navigate(horarUrlFor(button));
  };

  const toForm = (e) => {
    e.preventDefault();
    const form = document.getElementById('natal-form');
    if (!form) return;
    const bar = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--promo-bar-h') || '0', 10) || 0;
    const top = form.getBoundingClientRect().top + window.scrollY - bar - 64 - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  return (
    <section className={`px-4 ${className}`} data-testid="question-hero">
      <div className="max-w-3xl mx-auto text-center py-6 md:py-10">
        <h2 className="font-heading font-black text-slate-900 tracking-tight leading-tight text-[clamp(26px,5vw,44px)]">
          Он не пишет. Ждать или отпустить?
        </h2>
        <p className="mt-3 text-base md:text-lg text-slate-600">
          Ответ за минуту — бесплатно, без регистрации
        </p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto">
          {QUESTION_BUTTONS.map((b) => (
            <button
              key={b.key}
              type="button"
              onClick={() => ask(b)}
              className="w-full rounded-xl bg-sky-600 hover:bg-sky-700 active:bg-sky-800 text-white font-bold text-base md:text-lg py-3.5 px-4 shadow-md shadow-sky-200/60 transition-colors"
              data-testid={`question-btn-${b.key}`}
            >
              {b.label}
            </button>
          ))}
        </div>
        <a
          href="#natal-form"
          onClick={toForm}
          className="inline-block mt-5 text-sm md:text-base text-sky-700 underline underline-offset-4 hover:text-sky-900"
          data-testid="question-hero-to-natal"
        >
          Или построй свою натальную карту ↓
        </a>
      </div>
    </section>
  );
}
